import { useState, useEffect } from "react";
import { Form, Input, Select, Upload, Button, Breadcrumb, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { convertIntoFormData } from "../../../utils/utils";
import { useSelector } from "react-redux";


const { Option } = Select;

const CreateTicket = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const com_id = useSelector((store) => store.auth.userInfo.company_id);
  const comp_id = Number(localStorage.getItem('companyId')) || com_id;
  const navigate = useNavigate();

  // values.file = { fileList: [ { originFileObj: values.attachments?.fileList[0]?.originFileObj } ] }
  const onFinish = async (values) => {
    try {
      values.file = values.attachments?.fileList?.[0]?.originFileObj || null
      delete values.attachments;
      const formData = convertIntoFormData(values)
      formData.append("company_id", comp_id); // Append company ID to form data
      setIsLoading(true)
      const response = await axiosInstance.post(`/create-ticket/`, formData)
      console.log(response)
      if (response.status == 200) {
        form.resetFields();
        message.success(response.data.message);
        navigate(-1);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error create tickets:", error);
      message.error(error?.response?.data?.error);

    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <div className="sticky -top-6 bg-white dark:bg-[#17153B] z-10 shadow-sm p-4">
        <Breadcrumb className="text-lg font-medium text-gray-700">
          <Breadcrumb.Item>
            <Link to="/admin/support" className="hover:text-blue-600 transition-colors">
              Support Dashboard
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item className="text-blue-500 font-semibold">Add Ticket</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="bg-white border dark:bg-[#17153B] p-8 shadow-lg rounded-xl max-w-3xl mx-auto mt-6">
        <h2 className="text-3xl font-semibold mb-6 text-gray-800 dark:text-gray-200 text-center">Create New Ticket</h2>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="subject"
            label={<span className="font-medium text-gray-700">Subject</span>}
            rules={[{ required: true, message: "Enter subject" }]}
          >
            <Input placeholder="Enter subject" className="p-3 h-12 rounded-md focus:ring focus:ring-blue-200" />
          </Form.Item>

          <Form.Item
            name="subject_type"
            label={<span className="font-medium text-gray-700">Type</span>}
            rules={[{ required: true, message: "Select type" }]}
          >
            <Select className="w-full h-12 rounded-md focus:ring focus:ring-blue-200">
              <Option value="Query">Query</Option>
              <Option value="Issue">Issue</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Enter description" }]}
          >
            <Input.TextArea rows={6} placeholder="Enter description..." />
          </Form.Item>

          <Form.Item
            name="attachments"
            label={<span className="font-medium text-gray-700">Attachments</span>}
          >
            <Upload.Dragger
              name="file"
              multiple={false}
              maxCount={1}
              showUploadList={{ showRemoveIcon: false }}
              className="p-4 rounded-md transition-all"
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined className="text-3xl text-blue-500" />
              </p>
              <p className="text-gray-600">
                Drop a file here or <span className="text-blue-500 font-medium">Browse</span> (Up to 20 MB)
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item className="flex justify-center mt-6">
            <Button
              type="primary"
              htmlType="submit"
              className="px-6 text-lg font-semibold rounded-lg 
              bg-gradient-to-r from-blue-500 to-indigo-600 text-white 
              hover:from-blue-600 hover:to-indigo-700 shadow-md transition-all 
              h-auto min-h-[44px]" // Ensure proper auto height
              disabled={isLoading} // Disable button when loading
              loading={isLoading} // Show loading spinner
            >
              {isLoading ? "Processing..." : "Create Ticket"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default CreateTicket;
